import { AnimatePresence, motion } from 'framer-motion';
import { useGetParams } from './hooks/useGetParams';
import { useVote } from './hooks/useVote';

import AdvtFullSize from './components/AdvtFullSize/AdvtFullSize';
import Quiz from './components/Quiz/Quiz';
import Winner from './components/Winner/Winner';

import posterDefault from './assets/images/bgPoster.webp';
import bgDefaultVideo from './assets/video/bgVideo.webm';
import winnerPoster from './assets/images/winnerBgPoster.webp';
import winnerVideo from './assets/video/winnerBg.webm';

function App() {
  const { voteState, currentState } = useVote();
  const { marginTopQuiz, questionFontSize, bgVideo, bgPoster } = useGetParams();

  return (
    <div className="app-wrapper">
      <AnimatePresence mode="wait">
        {['S1', 'S2'].includes(currentState) && (
          <motion.div
            className="motionBlock"
            key="quiz"
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
            style={{ display: 'flex', flexDirection: 'column', gap: '5rem' }}
          >
            <div className="advt-wrapper">
              <AdvtFullSize />
            </div>

            <Quiz
              variants={voteState?.vars}
              title={voteState?.title}
              questionImgUrl={voteState?.questionImgUrl}
              currentState={currentState}
              marginTopQuiz={marginTopQuiz}
              idVote={voteState?.id}
              questionFontSize={questionFontSize}
            />
          </motion.div>
        )}

        {currentState === 'S3' && (
          <motion.div
            className="motionBlock"
            key={`${currentState}-quiz`}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Winner />
          </motion.div>
        )}
      </AnimatePresence>

      <video
        autoPlay="autoplay"
        muted="muted"
        loop
        id="bgVideo"
        poster={winnerPoster}
      >
        <source src={winnerVideo} type="video/webm" />
      </video>

      <AnimatePresence mode="wait">
        {currentState !== 'S3' && (
          <motion.video
            key="bgVideo"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.8 }}
            autoPlay="autoplay"
            muted="muted"
            loop
            id="bgVideo"
            poster={bgVideo === '1' ? posterDefault : bgPoster}
          >
            <source
              src={bgVideo === '1' ? bgDefaultVideo : bgVideo}
              type="video/webm"
            />
          </motion.video>
        )}
      </AnimatePresence>

      <div id="img-loader"></div>
    </div>
  );
}

export default App;
